const es_ES = {}

es_ES.strings = {
  addMoreFiles: 'Agregar más archivos',
  addingMoreFiles: 'Agregando más archivos',
  allowAccessDescription: 'Para tomar fotos o grabar video con tu cámara, por favor permite a este sitio el acceso a la cámara.',
  allowAccessTitle: 'Por favor permite el acceso a tu cámara',
  authenticateWith: 'Conectar a %{pluginName}',
  authenticateWithTitle: 'Por favor autentícate con %{pluginName} para seleccionar archivos',
  back: 'Atrás',
  addMore: 'Agregar más',
  browse: 'navegar',
  browseFiles: 'navegar',
  cancel: 'Cancelar',
  cancelUpload: 'Cancelar subida',
  chooseFiles: 'Seleccionar archivos',
  closeModal: 'Cerrar ventana flotante',
  companionError: 'Conexión con Companion falló',
  complete: 'Completado',
  connectedToInternet: 'Conectado a Internet',
  copyLink: 'Copiar enlace',
  copyLinkToClipboardFallback: 'Copia la siguiente URL',
  copyLinkToClipboardSuccess: 'Enlace copiado al portapapeles',
  creatingAssembly: 'Preparando subida...',
  creatingAssemblyFailed: 'Transloadit: No se pudo crear un Assembly',
  dashboardTitle: 'Cargador de archivos',
  dashboardWindowTitle: 'Ventana para cargar archivos (Presiona escape para cerrar)',
  dataUploadedOfTotal: '%{complete} de %{total}',
  done: 'Hecho',
  dropHereOr: 'Soltar archivos aquí o %{browse}',
  dropHint: 'Suelta tus archivos aquí',
  dropPasteBoth: 'Soltar archivos aquí, pegar o %{browse}',
  dropPasteFiles: 'Soltar archivos aquí, pegar o %{browse}',
  dropPasteFolders: 'Soltar archivos aquí, pegar o %{browse}',
  dropPasteImportBoth: 'Soltar archivos aquí, pegar, %{browse} o importar desde',
  dropPasteImportFiles: 'Soltar archivos aquí, pegar, %{browse} o importar desde',
  dropPasteImportFolders: 'Soltar archivos aquí, pegar, %{browse} o importar desde',
  editFile: 'Editar archivo',
  editing: 'Editando %{file}',
  emptyFolderAdded: 'Ningún archivo fue agregado desde la carpeta vacía',
  encoding: 'Codificando...',
  enterCorrectUrl: 'URL incorrecta: Por favor asegúrate que estás ingresando un enlace a un archivo',
  enterUrlToImport: 'Ingresa una URL para importar un archivo',
  exceedsSize: 'Este archivo excede el tamaño máximo de',
  failedToFetch: 'Companion no ha podido recuperar esta URL, por favor asegúrate que sea correcta',
  failedToUpload: 'Error al subir %{file}',
  fileSource: 'Fuente de archivo: %{name}',
  filesUploadedOfTotal: {
    '0': '%{complete} de %{smart_count} archivo subido',
    '1': '%{complete} de %{smart_count} archivos subidos',
    '2': '%{complete} de %{smart_count} archivos subidos',
  },
  filter: 'Filtrar',
  finishEditingFile: 'Terminar edición de archivo',
  folderAdded: {
    '0': 'Agregado %{smart_count} archivo desde %{folder}',
    '1': 'Agregados %{smart_count} archivos desde %{folder}',
    '2': 'Agregados %{smart_count} archivos desde %{folder}',
  },
  import: 'Importar',
  importFrom: 'Importar desde %{name}',
  loading: 'Cargando...',
  logOut: 'Cerrar sesión',
  myDevice: 'Mi Dispositivo',
  noFilesFound: 'No existen archivos o carpetas aquí',
  noInternetConnection: 'Sin conexión a Internet',
  pause: 'Pausar',
  pauseUpload: 'Pausar subida',
  paused: 'En pausa',
  poweredBy: 'Soportado por',
  processingXFiles: {
    '0': 'Procesando %{smart_count} archivo',
    '1': 'Procesando %{smart_count} archivos',
    '2': 'Procesando %{smart_count} archivos',
  },
  recordingLength: 'Duración de grabación %{recording_length}',
  removeFile: 'Eliminar archivo',
  resetFilter: 'Limpiar filtro',
  resume: 'Reanudar',
  resumeUpload: 'Reanudar subida',
  retry: 'Intentar nuevamente',
  retryUpload: 'Intentar subida nuevamente',
  saveChanges: 'Guardar cambios',
  selectX: {
    '0': 'Seleccionar %{smart_count}',
    '1': 'Seleccionar %{smart_count}',
    '2': 'Seleccionar %{smart_count}',
  },
  smile: 'Sonríe!',
  startRecording: 'Comenzar la grabación de video',
  stopRecording: 'Detener la grabación de video',
  takePicture: 'Tomar una foto',
  timedOut: 'Subida estancada por %{seconds} segundos, anulando.',
  upload: 'Subir',
  uploadComplete: 'Subida terminada',
  uploadFailed: 'Subida falló',
  uploadPaused: 'Subida pausada',
  uploadXFiles: {
    '0': 'Subir %{smart_count} archivo',
    '1': 'Subir %{smart_count} archivos',
    '2': 'Subir %{smart_count} archivos',
  },
  uploadXNewFiles: {
    '0': 'Subir +%{smart_count} archivo',
    '1': 'Subir +%{smart_count} archivos',
    '2': 'Subir +%{smart_count} archivos',
  },
  uploading: 'Subiendo',
  uploadingXFiles: {
    '0': 'Subiendo %{smart_count} archivo',
    '1': 'Subiendo %{smart_count} archivos',
    '2': 'Subiendo %{smart_count} archivos',
  },
  xFilesSelected: {
    '0': '%{smart_count} archivo seleccionado',
    '1': '%{smart_count} archivos seleccionados',
    '2': '%{smart_count} archivos seleccionados',
  },
  xMoreFilesAdded: {
    '0': '%{smart_count} archivo más agregado',
    '1': '%{smart_count} archivos más agregados',
    '2': '%{smart_count} archivos más agregados',
  },
  xTimeLeft: '%{time} restantes',
  youCanOnlyUploadFileTypes: 'Solo puedes subir: %{types}',
  youCanOnlyUploadX: {
    '0': 'Solo puedes subir %{smart_count} archivo',
    '1': 'Solo puedes subir %{smart_count} archivos',
    '2': 'Solo puedes subir %{smart_count} archivos',
  },
  youHaveToAtLeastSelectX: {
    '0': 'Tienes que seleccionar al menos %{smart_count} archivo',
    '1': 'Tienes que seleccionar al menos %{smart_count} archivos',
    '2': 'Tienes que seleccionar al menos %{smart_count} archivos',
  },
  selectAllFilesFromFolderNamed: 'Seleccionar todos los archivos de la carpeta %{name}',
  unselectAllFilesFromFolderNamed: 'Deselecciona todos los archivos de la carpeta %{name}',
  selectFileNamed: 'Seleccione archivo %{name}',
  unselectFileNamed: 'Deseleccionar archivo %{name}',
  openFolderNamed: 'Carpeta abierta %{name}',
}

es_ES.pluralize = function (n) {
  if (n === 1) {
    return 0
  }
  return 1
}

if (typeof window !== 'undefined' && typeof window.Uppy !== 'undefined') {
  window.Uppy.locales.es_ES = es_ES
}

module.exports = es_ES
